import { getAdapter } from '@zyf2e/adapt';
import commonApi from './commonApi';
var util = {
  PROD_HOST: 'zyyd.dia-solution.com',
  PRE_HOST: 'zyyd.pre.dia-solution.com',
  QA_HOST: 'zyyd.qa.dia-solution.com',
  adapter: getAdapter(),
  staticHosts: {
    qa: 'static.qa.91jkys.com',
    pre: 'static.pre.91jkys.com',
    online: 'static.91jkys.com'
  },
  ZYpayConfig: {
    bizId: 'MEDIC_SALE',
    bizSource: 'MEDIC_SALE',
    configKey: '5123656d',
    payWay: ['wechat_pub'],
    failUrl: encodeURIComponent(window.location.href),
    baseURL: commonApi.getGwApi(), //
    domain: `${commonApi.getPayDomain()}f2e/checkout/`,
    jkysWechatURL: `${commonApi.getGwApi()}/medicsale_patient/1.0/share_config`,
    loginKey: 'zyyd_login',
    wechatLoginApi: `${commonApi.getZyydApi()}/medicsale/wechatLogin?bizId=MEDIC_SALE`
  },
  tyApp: (function () {
    return /tangyi/.test(navigator.userAgent);
  })(),
  inWechat: (function () {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') != -1;
  })(),
  isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  },
  toArray(obj) {
    if (!Array.isArray) {
      Array.isArray = function isArray(o) {
        return Object.prototype.toString.call(o) == '[object Array]';
      };
    }
    if (!Array.isArray(obj)) {
      if (!this.isObject(obj)) {
        if (typeof obj === 'number' || typeof obj === 'string') {
          let temp = obj;
          obj = [];
          obj.push({ id: temp, num: 1 });
        } else {
          obj = [];
        }
      } else {
        let temp = obj;
        obj = [];
        obj.push(temp);
      }
    }
    return obj;
  },
  toString(value) {
    return value ? value.toString() : '';
  },
  clone: function (obj) {
    return obj && JSON.parse(JSON.stringify(obj));
  },
  getUrlParams: function (url) {
    //var pattern = /(\w+)=(\w+)/ig;
    var pattern = /[?&]([^=#]+)=([^&#]*)/g;
    url = url ? url : window.location.href;
    var searchParaMap = {};
    url.replace(pattern, function (a, b, c) {
      if (/%/.test(c)) {
        searchParaMap[b] = decodeURIComponent(c);
      } else {
        searchParaMap[b] = c;
      }
    });
    return searchParaMap;
  },

  getEnvUrl: function (url, t) {
    if (!url) {
      return false;
    }
    var type = t || '';
    var host = window.location.host;
    var protocol = location.protocol;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return type ? 'https://' + this.PROD_HOST + url : protocol + '//' + this.PROD_HOST + url;
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//' + this.PRE_HOST + url;
    } else {
      return protocol + '//' + this.QA_HOST + url;
    }
  },
  getImgUrl: function (url) {
    if (!url) {
      return false;
    }
    var host = window.location.host;
    var protocol = location.protocol;

    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//' + this.staticHosts.online + url;
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//' + this.staticHosts.online + url;
    } else {
      return protocol + '//' + this.staticHosts.qa + url;
    }
  },
  getQueryVariable(variable) {
    const query = window.location.href.split('?');
    if (query.length < 2) {
      return null;
    }
    const vars = query[1].split('&');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return null;
  },

  getMallPath: function (url) {
    return this.getImgUrl(url);
  },

  cache: function (key, value) {
    try {
      if (arguments.length === 2) {
        return localStorage.setItem(key, JSON.stringify(value));
      } else {
        return JSON.parse(localStorage.getItem(key));
      }
    } catch (e) {
      alert('do not support JSON.parse');
    }
  },
  clearCache: function (key) {
    localStorage.removeItem(key);
  },
  getDate: function (date, symbol, format) {
    if (!date) {
      return '';
    }
    if (!symbol) {
      symbol = '-';
    }
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (format == 'mmdd') {
      return [month, day].join(symbol);
    } else {
      return [year, month, day].join(symbol);
    }
  },
  getTime: function (date, symbol, format) {
    if (!date) {
      return '';
    }
    if (!symbol) {
      symbol = ':';
    }
    var d = new Date(date),
      hours = '' + d.getHours(),
      minutes = '' + d.getMinutes(),
      seconds = '' + d.getSeconds();
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;
    if (format == 'hhmmss') {
      return [hours, minutes, seconds].join(symbol);
    } else {
      return [hours, minutes].join(symbol);
    }
  },

  getCookie: function (name) {
    var cookies = document.cookie.split('; ');
    for (var i in cookies) {
      var arr = cookies[i].split('=');
      if (name == arr[0]) return unescape(arr[1]);
    }
    return null;
  },
  setCookie: function (name, value, expires, path, domain) {
    document.cookie =
      name +
      '=' +
      value +
      (expires ? '; expires=' + getExpires(expires) : '') +
      (path ? '; path=' + path : '') +
      (domain ? '; domain=' + domain : '');

    function getExpires(hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      return date.toGMTString();
    }
  },
  removeCookie: function (name, path, domain) {
    if (this.getCookie(name)) {
      document.cookie =
        name +
        '=' +
        (path ? ';path=' + path : '') +
        (domain ? ';domain=' + domain : '') +
        ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
  },

  // refreshReload: function() {
  //   let loc = window.location;
  //   const link = loc.search ? '&' : '';
  //   loc.search = loc.search + link + 'time=' + new Date().getTime();
  // },
  safeStr: function (str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  },
  submitOnce: (function () {
    var isRunning = false;
    return function (callback, context, time) {
      if (!isRunning) {
        isRunning = true;
        var temp = callback.call(context);
        if (temp && typeof temp.then === 'function') {
          temp.finally(() => {
            isRunning = false;
          });
        } else {
          setTimeout(function () {
            isRunning = false;
          }, time || 1000);
        }
        return temp;
      }
    };
  })(),
  getBirthdayFromIdCard: function (idCard) {
    idCard = idCard.toString();
    var birthday = '';
    if (idCard != null && idCard != '') {
      if (idCard.length == 15) {
        birthday = '19' + idCard.substr(6, 6);
      } else if (idCard.length == 18) {
        birthday = idCard.substr(6, 8);
      }

      birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
    }
    return birthday;
  },
  reAuth() {
    // 将zyyd_login设置为空或删除，不能设置成false
    this.removeCookie('zyyd_login', '/', location.host.replace('zyyd', ''));
    window.wx.wechatAuth(() => {}, location.href);
  },
  // 倒计时
  intervalFn(ms, cb = () => {}, downFn = () => {}, duringMs = 1000) {
    let timer = setTimeout(function timeoutFun() {
      ms -= duringMs;
      cb();
      if (ms >= 0) {
        timer = setTimeout(timeoutFun, duringMs);
      } else {
        downFn();
        clearTimeout(timer);
      }
    }, duringMs);
  },
  forceRedirect(url) {
    const loc = window.location;
    const re = /#.*$/;
    const reload = loc.href.replace(re, '') === url.replace(re, '');
    loc.href = url;
    if (reload) {
      loc.reload();
    }
  },
  setTitle(t) {
    document.title = t;
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
      var i = document.createElement('iframe');
      i.src = '/favicon.ico';
      i.style.display = 'none';
      i.onload = function () {
        setTimeout(function () {
          i.remove();
        }, 9);
      };
      document.body.appendChild(i);
    }
  },
  httpsReplace(str) {
    if (!str.includes('https')) {
      const url = str.replace(/^http/, 'https');
      return url;
    }
    return str;
  },
  wait(time) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  },
  parseParam(json) {
    if (!json) return '/';
    return (
      '?' +
      Object.keys(json)
        .map((v) => {
          return `${v}=${json[v]}`;
        })
        .join('&')
    );
  },

  toHHmmss(ms, format = 'cn') {
    const duration = ms;
    let seconds = parseInt(((duration / 1000) % 60) + '');
    let minutes = parseInt(((duration / (1000 * 60)) % 60) + '');
    let hours = Number(parseInt(duration / (1000 * 60 * 60) + ''));
    const h = hours < 10 ? '0' + hours : hours + '';
    const m = minutes < 10 ? '0' + minutes : minutes + '';
    const s = seconds < 10 ? '0' + seconds : seconds + '';
    const isCn = format === 'cn';
    return h + (isCn ? '小时' : ':') + m + (isCn ? '分' : ':') + s + (isCn ? '秒' : '');
  },
  isMobileNumValid(phone) {
    return /^1\d{10}$/.test(phone);
  },
  loadScript(url) {
    var script = document.createElement('script');
    script.src = url;
    script.async = false;
    document.head.appendChild(script);
  },
  /**
   * 压缩图片
   * @param {需要压缩的图片地址} imgUrl
   * @param {阿里oss压缩参数} oss
   * @returns 压缩后的图片地址
   */
  compressImg(imgUrl, oss = '?x-oss-process=image/resize,p_35') {
    if (!imgUrl) return '';
    const protocol = 'http://';
    return imgUrl.replace(protocol, 'https://') + oss;
  },

  parseDate (date, fmt = 'yyyy-MM-dd HH:mm:ss') {
    if (!date) {
      return date;
    }
    date = typeof date !== 'object' ? new Date(date) : date;
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 小时
      'H+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3) // 季度
    };
    const week = {
      '0': '日',
      '1': '一',
      '2': '二',
      '3': '三',
      '4': '四',
      '5': '五',
      '6': '六'
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[`${date.getDay()}`]
      );
    }
    if (/(S+)/.test(fmt)) {
      const ms = date.getMilliseconds();
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? ms
          : RegExp.$1.length == 2
          ? `00${ms}`.substr(`${ms}`.length)
          : `000${ms}`.substr(`${ms}`.length)
      );
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
      }
    }
    return fmt;
  }
};

window.util = util;
export default util;
